module.exports = __webpack_public_path__ + "static/media/financial-services.b980967e.svg";